export interface ServiceType {
  id: string;
  name: {
    en: string;
    zh: string;
  };
  description: {
    en: string;
    zh: string;
  };
  icon: string;
}

export const serviceTypes: ServiceType[] = [
  {
    id: "website",
    name: {
      en: "Website Development",
      zh: "網站開發",
    },
    description: {
      en: "Responsive websites designed for optimal user experience.",
      zh: "響應式網站設計，優化用戶體驗。",
    },
    icon: "computer",
  },
  {
    id: "platform",
    name: {
      en: "Platform Building",
      zh: "平台建設",
    },
    description: {
      en: "Complex platforms and systems with custom functionality.",
      zh: "具有定制功能的複雜平台和系統。",
    },
    icon: "dns",
  },
  {
    id: "software",
    name: {
      en: "Custom Software",
      zh: "定制軟件",
    },
    description: {
      en: "Tailored software solutions for specific business needs.",
      zh: "針對特定業務需求定制軟件解決方案。",
    },
    icon: "code",
  },
  {
    id: "app",
    name: {
      en: "App Development",
      zh: "應用程式開發",
    },
    description: {
      en: "Custom mobile applications for iOS and Android platforms.",
      zh: "為iOS和Android平台定制開發移動應用程式。",
    },
    icon: "phoneIphone",
  },
  {
    id: "game",
    name: {
      en: "Game Development",
      zh: "遊戲開發",
    },
    description: {
      en: "Engaging games for mobile, web, and desktop platforms.",
      zh: "為移動、網頁和桌面平台開發引人入勝的遊戲。",
    },
    icon: "sportsEsports",
  },
];

export default serviceTypes; 